var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHappyFace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#3863F0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.193 8.381h-6.385c-2.774 0-4.427 1.654-4.427 4.427v6.377c0 2.781 1.653 4.434 4.427 4.434h6.377c2.773 0 4.427-1.653 4.427-4.426v-6.385c.007-2.773-1.646-4.427-4.42-4.427m-5.86 3.337c.785 0 1.433.64 1.433 1.433a1.43 1.43 0 0 1-1.432 1.432 1.44 1.44 0 0 1-1.433-1.44c0-.785.648-1.425 1.433-1.425M16 21.395a3.723 3.723 0 0 1-3.718-3.718c0-.534.434-.976.968-.976h5.485a.97.97 0 0 1 .968.976A3.7 3.7 0 0 1 16 21.395m2.667-6.827c-.785 0-1.433-.64-1.433-1.432 0-.793.64-1.433 1.433-1.433.792 0 1.432.64 1.432 1.433 0 .792-.647 1.432-1.432 1.432"
})));
export default SvgHappyFace;